import { IChooseItems } from '../../../../components/mainContent/TableAllDishes'
import { IEdgeServers } from '../../../../core/api/dto/BuffetDishDto'
import React, { useState } from 'react'
import {
  AppNotification,
  NotificationType,
} from '../../../../components/notification/Notification'
import { useTranslation } from 'react-i18next'
import { ICategory } from '../../../../core/api/dto/CategoriesObjDto'
import {
  useDeleteCategoriesToFotoboxesMutation,
  useSendCategoriesToFotoboxesMutation,
} from '../../../../core/api/CategoryApi'
import { uniqFilter } from '../../DishesPage/hooks/useSentOnFotobox'

interface UseSentCategoryOnFotoboxProps {
  chooseItems: IChooseItems | null
  tableData: ICategory[]
  setChooseItems: React.Dispatch<React.SetStateAction<IChooseItems | null>>
}

interface UseSentCategoryOnFotoboxResponse {
  isDeleteMode: boolean
  deleteStations: IEdgeServers[] | null
  sentPopup: boolean
  closeSentPopup: () => void
  openDeleteStationPopup: () => void
  openSentPopup: () => void
  onSendCategories: (value: string[]) => void
  onDeleteStation: (value: string[]) => void
  isLoadingSend: boolean
}

export const useSentCategoryOnFotobox = ({
  tableData,
  chooseItems,
  setChooseItems,
}: UseSentCategoryOnFotoboxProps): UseSentCategoryOnFotoboxResponse => {
  const { t } = useTranslation()
  const [sentPopup, setSentPopup] = useState(false)
  const [isDeleteMode, setIsDeleteMode] = useState(false)
  const [deleteStations, setDeleteStations] = useState<IEdgeServers[] | null>(
    null,
  )

  const [sendCategoriesToFotoboxes, { isLoading: isLoadingSend }] =
    useSendCategoriesToFotoboxesMutation()
  const [deleteCategoriesToFotoboxes] = useDeleteCategoriesToFotoboxesMutation()

  const chooseCategories = tableData
    .filter((item) => chooseItems && chooseItems[item.id] && !item.archived)
    .map((item) => item.guid)

  const closeSentPopup = () => {
    setSentPopup(false)
    setIsDeleteMode(false)
    setDeleteStations(null)
  }
  const openDeleteStationPopup = () => {
    setSentPopup(true)
    setIsDeleteMode(true)
    const deleteStation = uniqFilter(
      tableData
        .filter((item) => chooseItems && chooseItems[item.id] && !item.archived)
        .map((item) => item.edgeServers)
        .flat(1),
    )
    setDeleteStations(deleteStation)
  }
  const openSentPopup = () => setSentPopup(true)

  const onSendCategories = (value: string[]) => {
    if (value.length && chooseCategories.length) {
      sendCategoriesToFotoboxes({
        categoriesGuids: chooseCategories,
        edgeServersGuids: value,
      })
        .unwrap()
        .then(() => {
          AppNotification({
            type: NotificationType.success,
            msg: t('Категории успешно отправлены на выбранные станции'),
          })
          setChooseItems(null)
          setSentPopup(false)
        })
    }
  }
  const onDeleteStation = (value: string[]) => {
    if (value.length && chooseCategories.length) {
      deleteCategoriesToFotoboxes({
        categoriesGuids: chooseCategories,
        edgeServersGuids: value,
      })
        .unwrap()
        .then(() => {
          AppNotification({
            type: NotificationType.success,
            msg: t('Категории успешно удалены с выбранных станций'),
          })
          setChooseItems(null)
          setSentPopup(false)
          setIsDeleteMode(false)
          setDeleteStations(null)
        })
    }
  }

  return {
    isDeleteMode,
    deleteStations,
    sentPopup,
    closeSentPopup,
    openSentPopup,
    openDeleteStationPopup,
    onDeleteStation,
    onSendCategories,
    isLoadingSend,
  }
}
